import BreadCrumb from "../common/breadcrumb";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import AboutMain from "./about";
import Video from "./video";
import Certification from "./certification";
import Team from "./team";
import FooterTwo from "../../layout/footers/footer-two";
import {useEffect, useState} from "react";
import {getCMSGeneral} from "../../utils/cms.utils";

const AboutUs = () => {
    const [general, setGeneral] = useState(null);

    useEffect(() => {
        setGeneral(getCMSGeneral());
    }, []);
    return (
        <>
            <SEO pageTitle="About Us"/>
            <HeaderTwo/>
            <BreadCrumb title={`About ${general?.companyName} (${general?.companyShortname})`}
                        items={[
                            {label: "About Us"},
                        ]}/>
            <AboutMain/>
            <Video/>
            <Certification/>
            <Team/>
            <FooterTwo/>
        </>
    );
};

export default AboutUs;